import React from 'react'
import styled from '@emotion/styled'
import { Form } from 'stylist'

const TwoFAForm = styled.div`
  width: 100%;
`

const Input = styled(Form.Input)`
  margin-bottom: 16px;
`

const StyledSubmitButton = styled(Form.SubmitButton)`
  margin-bottom: 24px !important;
`

const TwoFactorForm = ({ notify, authenticate }) => {
  return (
    <TwoFAForm>
      <Form
        initialValues={{
          authenticationCode: '',
        }}
        onSubmit={({ authenticationCode }) => {
          authenticate('oauth2-password-grant', {
            otp_attempt: authenticationCode,
          }).catch(({ payload: { error } }) => {
            if (error === 'two_fa_error') {
              notify('warning', 'Authentication code incorrect / expired.')
            }else if (error === 'password_expired') {
              notify('info', 'Your password is expired, please reset.')
            }
          })
        }}
      >
        <Form.Group>
          <label htmlFor="authenticationCode">Authentication code</label>
          <Input
            type="text"
            id="authenticationCode"
            name="authenticationCode"
            autoComplete="off"
            placeholder="Enter the code from Google Authenticator app"
          />
          <StyledSubmitButton block={true}>Verify</StyledSubmitButton>
        </Form.Group>
      </Form>
    </TwoFAForm>
  )
}

export default TwoFactorForm



// WEBPACK FOOTER //
// ./src/routes/login/components/TwoFactorForm.js